var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroku(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#FFD15C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.676 14H23.762C20.554 14 18 16.562 18 19.76V72.24C18 75.438 20.554 78 23.762 78H69.676C72.876 78 75.438 75.438 75.438 72.24V19.76C75.438 16.562 72.884 14 69.676 14V14ZM72.238 72.24C72.238 73.678 71.112 74.802 69.676 74.802H23.762C22.324 74.802 21.2 73.676 21.2 72.24V19.76C21.2 18.322 22.326 17.198 23.762 17.198H69.676C71.114 17.198 72.238 18.324 72.238 19.76V72.24ZM32.396 68.394L39.594 62L32.396 55.606V68.394ZM58.324 42.48C57.042 41.198 54.646 39.606 50.646 39.606C46.324 39.606 41.844 40.72 38.646 41.844V23.606H32.238V51.28L36.718 49.198C36.718 49.198 44.084 45.844 50.478 45.844C53.676 45.844 54.478 47.606 54.478 49.198V68.396H60.884V49.198C61.042 48.72 61.042 45.198 58.324 42.48ZM49.844 34H56.238C59.112 30.634 60.56 27.28 61.04 23.606H54.646C53.998 27.28 52.396 30.636 49.844 34Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/heroku.2296dd4ea5e30e64aa6137c3ce80a6b2.svg";
export { ForwardRef as ReactComponent };